import SnackbarContainer from './SnackbarContainer';

export default SnackbarContainer;
